/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SectionModalUpdateMutationVariables = {|
  sectionId: string,
  name: string,
|};
export type SectionModalUpdateMutationResponse = {|
  +recipeSectionUpdate: ?{|
    +recipeSection: ?{|
      +id: string,
      +name: ?string,
    |}
  |}
|};
export type SectionModalUpdateMutation = {|
  variables: SectionModalUpdateMutationVariables,
  response: SectionModalUpdateMutationResponse,
|};
*/


/*
mutation SectionModalUpdateMutation(
  $sectionId: ID!
  $name: String!
) {
  recipeSectionUpdate(input: {id: $sectionId, name: $name}) {
    recipeSection {
      id
      name
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sectionId",
    "type": "ID!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name",
    "type": "String!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "sectionId"
          },
          {
            "kind": "Variable",
            "name": "name",
            "variableName": "name"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "RecipeUpdateSectionPayload",
    "kind": "LinkedField",
    "name": "recipeSectionUpdate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecipeSectionNode",
        "kind": "LinkedField",
        "name": "recipeSection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SectionModalUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SectionModalUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "SectionModalUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation SectionModalUpdateMutation(\n  $sectionId: ID!\n  $name: String!\n) {\n  recipeSectionUpdate(input: {id: $sectionId, name: $name}) {\n    recipeSection {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f7857504607f29875310773f29331e4f';

module.exports = node;
